export default {
  actions: {
    RECEIVE_BRAND: 'RECEIVE_BRAND',
  },
};
